import { gql } from '@apollo/client';

export const GET_TEAM_NAMES = gql`
  query GetTeamNames($seasonId: Int!) {
    teams(where: { season: { _eq: $seasonId } }) {
      id
      name
    }
  }
`;
